<template>
  <el-col class="mb10" :xs="24" :sm="w100 ? 24 : 12" :md="w100 ? 24 : w50 ? 12 : 8">
    <div class="w100 flex-box al-c">
      <div class="tx-r" :style="{ 'width': this.width ? this.width + 'em' : 'auto' }">{{ typeData.label }}：</div>
      <div class="flex-1">
        <el-date-picker v-model="value" value-format="yyyy-MM-dd" type="date" :placeholder="typeData.placeholder ? typeData.placeholder : '选择' + typeData.label"></el-date-picker>
      </div>
    </div>
  </el-col>
</template>

<script>
export default {
  name: "DateComp",
  props: ["type-data", "w50", "w100", "width"],
  components: {},
  data() {
    return {
      value: this.typeData.value ? this.typeData.value : null
    };
  },
  created() {},
  computed: {},
  mounted() {},
  methods: {}
};
</script>

<style scoped>
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: auto;
}
</style>
